import React from "react";
import SetPassword from "../../organisms/InitialPagesComponents/SetPassword/SetPassword";

function SetPasswordPage() {
  return <SetPassword />;
}

export default SetPasswordPage;
